<template>
    <div class="box">
        <div class="field">
            <p class="title">Register</p>
        </div>
        <hr style="margin-left:25px;margin-right:25px;"/>
        <table>
            <tr>
                <td>
                    <p class="textlabel">Username</p>
                </td>
                <td style="width:100%">
                    <input id="username" class="textfield" type="username" v-model="username"></input>
                </td>
                <td>
                    <p class="smalltext">(6 characters minimum)</p>
                </td>
            </tr>
            <tr>
                <td>
                    <p class="textlabel">Full Name</p>
                </td>
                <td>
                    <input class="textfield" type="text" v-model="name"></input>
                </td>
            </tr>
            <tr>
                <td>
                    <p class="textlabel">Company</p>
                </td>
                <td>
                    <input class="textfield" type="text" v-model="company"></input>
                </td>
            </tr>
            <tr>
                <td>
                    <p class="textlabel">Position</p>
                </td>
                <td>
                    <input class="textfield" type="text" v-model="position"></input>
                </td>
            </tr>
            <tr>
                <td>
                    <p class="textlabel">Phone Number</p>
                </td>
                <td>
                    <input class="textfield" type="tel" v-model="phone"></input>
                </td>
            </tr>
            <tr>
                <td>
                    <p class="textlabel">Email</p>
                </td>
                <td>
                    <input class="textfield" type="email" v-model="email"></input>
                </td>
            </tr>
            <tr>
                <td>
                    <p class="textlabel">Password</p>
                </td>
                <td>
                    <input class="textfield" type="password" v-model="password"></input>
                </td>
                <td>
                    <label class="smalltext">(8 characters minimum)</label>
                </td>
            </tr>
            <tr>
                <td>
                    <p class="textlabel">Retype Password</p>
                </td>
                <td>
                    <input class="textfield" type="password" v-model="repassword" @keydown.enter="signup()"></input>
                </td>
            </tr>
        </table>
        <div class="field">
            <button type="button" v-on:click="cancel()">Cancel</button>
            <button type="button" v-on:click="signup()">Register</button>
        </div>
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
	data() {
		return {
            username: '',
            name: '',
            company: '',
            position: '',
            phone: '',
			email: '',
            password: '',
            repassword: ''
		}
	},
	methods: {
        cancel (){
            router.push('/0200');
        },
        signup() {
            api.postData(
                {
                    type:"signup",
                    data:{
                        pageid:PAGES.SIGNUP_PAGE,
                        data:[
                            this.username,
                            this.name,
                            this.email,
                            this.password,
                            this.repassword,
                            this.company,
                            this.position,
                            this.phone,
                            'krypto'
                        ]
                    }
                }
            ).then((res) => {
	            if(res.data.errors.length>0) {
                    var message = '';
                    for(var i = 0;i<res.data.errors.length;i++){
                        message+="• "+res.data.errors[i]+'\n';
                    }
                    alert("𝗘𝗿𝗿𝗼𝗿\n\n"+message);
                }else{
                    alert("Succesfully created user account\nWe have sent you a confirmation email");
                }
	        });
        }
	}
}
</script>

<style scoped>
.box{
    margin-right: 25%;
    margin-left: 25%;
    margin-top: 55px;
    border: 3px solid #35495E;
    border-radius: 20px;
}

.field{
    padding:10px;
    text-align:center;
}

.textlabel{
    white-space:nowrap;
    font-weight:bold;
    color:#35495E;
}

.smalltext{
    white-space:nowrap;
    font-size:14px;
    color:#35495E;
}

.textfield{
    width:100%;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
}

table {
    table-layout:auto;
    margin:auto;
    width:75%;
    border: none;
}
td {
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/file/Signup.vue